import { Syntax, VariableToken } from '@trlogic/ui-pack';
import VariableType from '../constant/VariableType';
import ComponentUtil from './ComponentUtil';
import ComponentName from '../constant/ComponentName';

export class ExpressionUtil {
  public static isEmpty = (syntax: Syntax | undefined): boolean => {
    if (syntax == undefined || syntax.children == undefined || syntax.children.length == 0) return true;
    return syntax.children.every((c) => c.value.type == 'Empty');
  };

  public static onNavigateToken = (syntax: Syntax) => {
    let link;
    const name = (syntax.value as VariableToken).name;
    const variableType = (syntax.value as VariableToken).variableType;
    switch (variableType as any) {
      case VariableType.EVENT_VARIABLE:
      case VariableType.PREVIOUS_EVENT_VARIABLE:
        const event = (syntax.value as VariableToken).args?.event;
        link = ComponentUtil.handleLink(ComponentName.TRANSACTION, event, { type: 'event', name: event });
        break;
      case VariableType.ML_OPS_VARIABLE:
        link = ComponentUtil.handleLink(ComponentName.AI_MODEL, name, {});
        break;
      case VariableType.BASIC:
        link = ComponentUtil.handleLink(ComponentName.BASIC_VARIABLE, name, { type: variableType, name });
        break;
      case VariableType.QUERY:
        link = ComponentUtil.handleLink(ComponentName.QUERY_VARIABLE, name, { type: variableType, name });
        break;
      case VariableType.LIST:
        link = ComponentUtil.handleLink(ComponentName.LIST_VARIABLE, name, { type: variableType, name });
        break;
      case VariableType.API:
        link = ComponentUtil.handleLink(ComponentName.API_VARIABLE, name, { type: variableType, name });
        break;
      case VariableType.VELOCITY:
        link = ComponentUtil.handleLink(ComponentName.VELOCITY, name, { type: variableType, name });
        break;
      case VariableType.STREAM_ROW_VARIABLE:
        const stream = (syntax.value as VariableToken).args?.stream;
        link = ComponentUtil.handleLink(ComponentName.STREAM, stream, {});
        break;
    }
    if (link == null) {
      return;
    }
    window.open(link, '_blank');
  };
}
